import { render } from "./HandoffView.vue?vue&type=template&id=3b53b6cf&scoped=true"
import script from "./HandoffView.vue?vue&type=script&lang=js"
export * from "./HandoffView.vue?vue&type=script&lang=js"

import "./HandoffView.vue?vue&type=style&index=0&id=3b53b6cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b53b6cf"]])

export default __exports__